import styled from '@emotion/styled'

export const SuggestionsListWrapper = styled.div`
  margin-top: 24px;
`
